import { useNavigate } from "@solidjs/router";
import { useApi, isOk } from "../../api";
import { createSignal, For, onMount } from "solid-js";
import { ItemEntry } from "../../models/ItemEntry";
import Text from "../../components/Text";
import ItemStackView from "../../components/ItemStackView";
import { fromIdentifier } from "../../services/itemRefAdapters";


export function AllItems() {

    const api = useApi();
    const navigate = useNavigate();

    const [items, setItems] = createSignal<ItemEntry[]>([]);

    async function getItems() {
        const res = await api.itemEntry.getItemEntries();
        if (isOk(res.data)) setItems(res.data.value.items as unknown as ItemEntry[]);
    }

    onMount(getItems);

    return (
        <div class="dashboard-page">
            <h1><Text val="ALL_ITEMS" /></h1>
            <button onClick={() => navigate('new')}><Text val="NEW" /></button>
            <table class="sessiontable">
                <thead>
                    <tr>
                        <td><Text val="ICON" /></td>
                        <td><Text val="MINECRAFT_ID" /></td>
                        <td><Text val="NAME" /></td>
                        <td><Text val="PURCHASE_1X" /></td>
                        <td><Text val="PURCHASE_64X" /></td>
                        <td><Text val="PURCHASE_DK" /></td>
                        <td>$ / 1x</td>
                        <td>$ / 16x</td>
                        <td>$ / 32x</td>
                        <td>$ / 64x</td>
                        <td>$ / 3x 64x</td>
                        <td>$ / 9x 64x</td>
                        <td>$ / DK</td>
                        <td><i class="fa-solid fa-pen-to-square"></i></td>
                    </tr>
                </thead>
                <tbody>
                    <For each={items()}>
                        {
                            (item) => (
                                <tr class="item">
                                    <td>
                                        <ItemStackView stack={fromIdentifier(item.minecraftId)} />
                                    </td>
                                    <td>
                                        <p>{item.minecraftId}</p>
                                    </td>
                                    <td>...</td>
                                    <td>${item.purchasePriceSingle}</td>
                                    <td>${item.purchasePriceSingle * 64}</td>
                                    <td>${item.purchasePriceSingle * 64 * 54}</td>
                                    <td>${item.singlePrice}</td>
                                    <td>${item.quaterStackPrice}</td>
                                    <td>${item.halfStackPrice}</td>
                                    <td>${item.stackPrice}</td>
                                    <td>${item.threeStacksPrice}</td>
                                    <td>${item.nineStacksPrice}</td>
                                    <td>${item.doubleChestPrice}</td>
                                    <td><button onClick={() => navigate('/items/' + item.id)}><i class="fa-solid fa-pen-to-square"></i></button></td>
                                </tr>
                            )
                        }
                    </For>
                </tbody>
            </table>
        </div>
    );
}